// Parallax Hero
// Parallax Hero
window.addEventListener('scroll', () => {
  const hero = document.querySelector('.banner__media img, .banner__media video');
  if (hero) {
    const scrollY = window.scrollY;
    hero.style.transform = `translateY(${scrollY * 0.3}px)`;
  }
});


// Scroll-Reveal
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('luxar-visible');
    }
  });
}, { threshold: 0.15 });

document.querySelectorAll('.multicolumn, .image-with-text, .footer').forEach(el => {
  el.classList.add('luxar-reveal');
  observer.observe(el);
});
